import { useState, useRef, useEffect } from "react";
import liverpoolStreet from "../assets/LiverpoolStreet.png";
import onlineTherapy from "../assets/onlineTherapy.png";

const doctors = [
  {
    name: "Dr Benjamin Piper",
    phone: "07929040880",
    email: "benjamin.piper@irise-psychology.london",
  },
  {
    name: "Dr René De Barr",
    phone: "07539447298",
    email: "rene.debarr@irise-psychology.london",
  },
];

export default function Locations() {
  const [activeLocation, setActiveLocation] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);

  const londonRef = useRef(null);
  const onlineRef = useRef(null);

  useEffect(() => {
    if (activeLocation === "london" && londonRef.current) {
      londonRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    if (activeLocation === "online" && onlineRef.current) {
      onlineRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeLocation]);

  return (
    <section id="locations" className="py-5 section-tint">
      <div className="py-4 main-wrap">
        <div className="text-center mb-4">
          <h2 className="h1 fw-semibold mb-2">Find Us</h2>
          <p className="text-secondary mb-0">
            Personal appointments in London or virtual appointments online.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden">
              <img className="card-img-top location-img" src={liverpoolStreet} alt="" />
              <div className="card-body text-center p-4">
                <h3 className="h5 fw-semibold mb-1">Liverpool Street</h3>
                <p className="text-secondary mb-3">E1 7LF</p>
                <button
                  className="btn btn-outline-brand fw-semibold"
                  onClick={() => setActiveLocation("london")}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden">
              <img className="card-img-top location-img" src={onlineTherapy} alt="" />
              <div className="card-body text-center p-4">
                <h3 className="h5 fw-semibold mb-1">Online Virtual Appointment</h3>
                <p className="text-secondary mb-3">Available worldwide</p>
                <button
                  className="btn btn-outline-brand fw-semibold"
                  onClick={() => setActiveLocation("online")}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        </div>

        {activeLocation === "london" && (
          <div ref={londonRef} className="row justify-content-center mt-5">
            <div className="col-lg-10">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="row g-0">
                  <div className="col-md-5">
                    <img
                      src={liverpoolStreet}
                      alt=""
                      className="img-fluid h-100 w-100 object-fit-cover"
                    />
                  </div>

                  <div className="col-md-7">
                    <div className="p-4 p-lg-5">
                      <h4 className="fw-semibold mb-1">Face to Face Appointments</h4>
                      <p className="text-secondary mb-3">
                        Liverpool Street, London E1 7LF
                      </p>

                      <p className="text-secondary mb-4">
                        Private one to one sessions in a calm Central London setting.
                      </p>

                      <ul className="list-unstyled text-secondary mb-4">
                        <li className="mb-2">✔ One to one confidential sessions</li>
                        <li className="mb-2">✔ Central London location</li>
                        <li>✔ Stress, anxiety, and wellbeing support</li>
                      </ul>

                      <div className="mb-4">
                        <button
                          className="btn btn-outline-brand fw-semibold px-4"
                          onClick={() => setShowBookingModal(true)}
                        >
                          Book an appointment
                        </button>
                      </div>

                      <div className="ratio ratio-16x9 rounded-3 overflow-hidden">
                        <iframe
                          src="https://www.google.com/maps?q=E1%207LF&output=embed"
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Liverpool Street Map"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeLocation === "online" && (
          <div ref={onlineRef} className="row justify-content-center mt-5">
            <div className="col-lg-10">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="row g-0">
                  <div className="col-md-5">
                    <img
                      src={onlineTherapy}
                      alt=""
                      className="img-fluid h-100 w-100 object-fit-cover"
                    />
                  </div>

                  <div className="col-md-7">
                    <div className="p-4 p-lg-5">
                      <h4 className="fw-semibold mb-1">Online Appointments</h4>
                      <p className="text-secondary mb-3">
                        Secure video sessions from anywhere
                      </p>

                      <p className="text-secondary mb-4">
                        Private one to one support with the comfort of joining from
                        your home, workplace, or any space you feel relaxed in.
                      </p>

                      <ul className="list-unstyled text-secondary mb-4">
                        <li className="mb-2">✔ Secure video based sessions</li>
                        <li className="mb-2">✔ No travel required</li>
                        <li>✔ Flexible scheduling worldwide</li>
                      </ul>

                      <div className="mb-4">
                        <button
                          className="btn btn-outline-brand fw-semibold px-4"
                          onClick={() => setShowBookingModal(true)}
                        >
                          Book an appointment
                        </button>
                      </div>

                      <div className="card border rounded-4 p-4">
                        <div className="d-flex flex-wrap gap-2">
                          <span className="badge text-bg-light">Video call</span>
                          <span className="badge text-bg-light">Worldwide</span>
                          <span className="badge text-bg-light">Private sessions</span>
                          <span className="badge text-bg-light">Flexible times</span>
                        </div>
                        <div className="mt-3 text-secondary">
                          You will receive joining details after booking.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showBookingModal && (
          <>
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content rounded-4">
                  <div className="modal-header">
                    <h5 className="modal-title fw-semibold">Book an Appointment</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowBookingModal(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <p className="text-secondary mb-4">
                      Appointments can be booked by phone, email, or online.
                    </p>

                    <div className="mb-4">
                      <h6 className="fw-semibold mb-2">Online booking</h6>
                      <a
                        href="https://mentispsychology.cliniko.com/bookings#location"
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-brand fw-semibold"
                      >
                        Book online via Cliniko
                      </a>
                    </div>

                    <hr />

                    <h6 className="fw-semibold mb-3">Contact a doctor directly</h6>

                    <div className="row g-3">
                      {doctors.map((doctor) => (
                        <div key={doctor.email} className="col-md-6">
                          <div className="border rounded-4 p-3 h-100">
                            <div className="fw-semibold mb-2">{doctor.name}</div>

                            <div className="text-secondary mb-1">
                              Phone{" "}
                              <a href={`tel:${doctor.phone}`} className="text-decoration-none">
                                {doctor.phone}
                              </a>
                            </div>

                            <div className="text-secondary">
                              Email{" "}
                              <a href={`mailto:${doctor.email}`} className="text-decoration-none">
                                {doctor.email}
                              </a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setShowBookingModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal-backdrop fade show"
              onClick={() => setShowBookingModal(false)}
            />
          </>
        )}
      </div>
    </section>
  );
}
